function useFormikArray(fieldName, values, setFieldValue) {
  const array = fieldName.split('.').reduce((acc, key) => acc?.[key], values) || []; // eslint-disable-line

  const add = (item) => {
    setFieldValue(fieldName, [...array, item]);
  };

  const update = (index, newItem) => {
    const updated = [...array];

    updated[index] = newItem;

    setFieldValue(fieldName, updated);
  };

  const remove = (index) => {
    const updated = [...array];

    updated.splice(index, 1);

    setFieldValue(fieldName, updated);
  };

  const replaceAll = (newArray) => {
    setFieldValue(fieldName, newArray);
  };

  return {
    add,
    array,
    update,
    remove,
    replaceAll,
  };
}

export {
  useFormikArray,
};
